<template>
  <!-- eslint-disable vue/no-v-html -- a static illustration from the design, no user input -->
  <span
    class="mcp-empty-illustration"
    aria-hidden="true"
    v-html="svg"
  />
</template>

<script>
const SVG = '<svg preserveAspectRatio="none" overflow="visible" style="display: block;" width="86" height="74" viewBox="0 0 86 74" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="empty"><path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M10.1172 26.8707C4.30826 36.6668 1.28457 49.4475 7.23739 59.0977C12.7889 68.0972 25.5844 66.4422 35.9661 68.7745C45.9807 71.0244 56.0645 77.0575 65.069 72.09C75.3057 66.4426 81.0907 55.0229 81.8773 43.4465C82.7135 31.1403 79.3593 17.7695 69.2426 10.6656C59.6721 3.94515 47.0757 7.93458 35.7327 11.0435C25.5428 13.8363 15.4842 17.8198 10.1172 26.8707Z" fill="#F1F7FF"/><g id="box" filter="url(#filter0_d_0_12)"><path id="Path" d="M10.6601 21.4811H75.5754V52.6411C75.5754 53.9864 74.4848 55.0771 73.1394 55.0771H13.0961C11.7507 55.0771 10.6601 53.9864 10.6601 52.6411V21.4811Z" fill="#B8C9E0"/><path id="Path_2" d="M10.4938 9.67175L4.15926 23.6075C3.91848 24.1103 3.95248 24.7015 4.24932 25.1735C4.54615 25.6454 5.06433 25.9321 5.62185 25.9328H80.3764C80.9461 25.9328 81.4742 25.634 81.7678 25.1457C82.0614 24.6574 82.0776 24.0509 81.8105 23.5476L75.607 9.67175H10.4938Z" fill="#E4EEFC"/><path id="Path_3" d="M62.4909 0L75.6065 9.67177H10.4883L23.5339 0H62.4909Z" fill="#CDDBEE"/><path id="Path_4" d="M23.5339 0V9.67177H10.4883L23.5339 0Z" fill="#B8C9E0"/><path id="Path_5" d="M62.492 0V9.66467L75.6076 9.67177L62.492 0Z" fill="#B8C9E0"/></g></g><defs><filter id="filter0_d_0_12" x="-2.53647e-09" y="0" width="86" height="63.0771" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/><feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_0_12"/><feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_0_12" result="shape"/></filter></defs></svg>';

export default {
  name: 'McpEmptyIllustration',
  computed: {
    svg: () => SVG,
  },
};
</script>

<style scoped>
.mcp-empty-illustration {
  position: absolute;
  top: 0;
  bottom: 0;
  left: -5.13%;
  right: -5.13%;
}

.mcp-empty-illustration :deep(svg) {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
